<template>
    <div :style="questionStyle()" class="practice-question">
        <PracticeQuestionInfo
            v-bind="widget()"
            :expert-view="expertView"
            :number="questionNumber"
            :name="question.name"
            :question="question"
            :quiz="quiz"
        />

        <PracticeQuestionDefaultOptions
            v-if="interactive"
            :attempt="attempt"
            :quiz="quiz"
            :question="question"
            @next="$emit('next')"
        />

        <div class="flex" :style="{ justifyContent: question.align || 'center' }">
            <img
                v-if="question.type.slug === QUESTION_TYPES.IMAGE && question.image"
                style="object-fit: cover; max-width: 100%; border-radius: 8px"
                :width="question.align === 'stretch' ? '100%' : question.image_width"
                height="auto"
                :src="question.image.url"
            />

            <div
                :style="{
                    maxWidth: question.align === 'stretch' ? '100%' : `${question.image_width}px`,
                    width: '100%'
                }"
                v-if="question.type.slug === QUESTION_TYPES.VIDEO"
            >
                <YoutubePlayer
                    v-if="question.playback_extended && question.playback_extended.type === 'youtube'"
                    :key="keyUpdate"
                    :videoUrl="question.playback_extended.url"
                />
                <VimeoPlayer
                    v-else-if="question.playback_extended && question.playback_extended.type === 'vimeo'"
                    :key="keyUpdate"
                    :videoUrl="question.playback_extended.url"
                />
            </div>
        </div>

        <PracticeActionsContainer :question="question" :quiz="quiz" v-if="interactive" v-on="$listeners" />
    </div>
</template>

<script>
import PracticeQuestionDefaultOptions from "./components/PracticeQuestionDefaultOptions"
import PracticeActionsContainer from "./components/PracticeActionsContainer.vue"
import PracticeQuestionInfo from "./components/PracticeQuestionInfo"

import PracticeMixin from "./_mixin"

import YoutubePlayer from "@components/Players/YoutubePlayer.vue"
import VimeoPlayer from "@components/Players/VimeoPlayer.vue"
import DebouncerMixin from "@helpers/debouncer-mixin"

export default {
    mixins: [PracticeMixin, DebouncerMixin],
    components: {
        PracticeQuestionInfo,
        PracticeActionsContainer,
        PracticeQuestionDefaultOptions,
        YoutubePlayer,
        VimeoPlayer
    },
    name: "PracticeMediaAnswer",
    data() {
        return {
            keyUpdate: 0
        }
    },
    watch: {
        "question.playback_extended": {
            handler() {
                this.debouncer.exec(() => {
                    this.keyUpdate++
                }, 100)
            },
            deep: true
        }
    }
}
</script>
